import assetUtils, { Asset } from 'app-lib/assetUtils'
import React from 'react'
import { Icon } from 'ui-framework'

interface IAssetDropdownSimpleProps {
  assets: Asset[]
  selectedAsset: Asset
  onSelect: (asset: Asset) => void
  emptyLabel?: string
  emptyIcon?: string
}

export function AssetDropdownSimple(props: IAssetDropdownSimpleProps) {
  return (
    <>
      {props.assets
        .filter((asset) => asset !== props.selectedAsset)
        .map((asset) => {
          const { displayName, spriteLogo } = assetUtils.getCommon(asset)
          const iconName = spriteLogo || props.emptyIcon
          return (
            <div key={asset} className="asset-dropdown-item" onClick={() => props.onSelect(asset)}>
              <Icon name={iconName} size={24} className="margin-right-05" />
              <b className="txt-default">{iconName ? displayName || props.emptyLabel : 'None'}</b>
            </div>
          )
        })}
    </>
  )
}

export default React.memo(AssetDropdownSimple)
